import { useState } from "react";
import Aaview from "./Aaview";
import Aaedit from "./Aaedit";
import { createContext } from "react";
import { useQuery } from "react-query";
import axios from "../../axios/axios";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
export const AasetupContext = createContext(null);
const Aasetup = () => {
    const [editMode,setEditMode] = useState(false);
    const {authData} = useContext(AuthenticationContext);
    const {isLoading,data:AAData,refetch} = useQuery(
        ['getApprovalAdivce'],async()=>{
            const resp = await axios.get('/approval/advice',{
                headers:{
                    Authorization:`Bearer ${authData?.token}`
                }
            })
            console.log(resp?.data?.data);
            return resp?.data?.data;
        },
        {
            refetchOnWindowFocus:false
        }
    )
    return(
        <div className="flex_adjust min-h-screen">
            <AasetupContext.Provider value={{setEditMode,isLoading,AAData,authData,refetch}}>
                {
                    editMode ? <Aaedit /> : <Aaview />
                }
            </AasetupContext.Provider>
        </div>
    )
}

export default Aasetup;